import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import firebaseConfigProd from './firebaseConfigProd'
import firebaseConfigAcc from './firebaseConfigAcc'

let firebaseApp = null;

let host = window.location.hostname;

// Use PROD Firebase only for PROD environment.
if (host === 'www.werkgeluk.nl') {
  firebaseApp = firebase.initializeApp(firebaseConfigProd);
} else {
  firebaseApp = firebase.initializeApp(firebaseConfigAcc);
}

export default firebaseApp.firestore();
const firestore = firebaseApp.firestore();
const settings = {timestampsInSnapshots: true};
firestore.settings(settings);



// WEBPACK FOOTER //
// ./src/components/firebaseInit.js